<fdx-alert
    [classes]="tierAlertClasses"
    [dismissible]="dismissible"
    [iconOverrideContent]="iconOverride"
    [title]="title"
    [separateTitle]="true"
    [body]="body"
    [extraContent]="extraContent"
    (dismissed)="close()">
    <ng-content></ng-content>
</fdx-alert>

<ng-template #iconOverride>
    <fdx-surface-tier-icon-button
        [clickable]="false"
        [tier]="tier"
        size="sm"
        class="pt-1"/>
</ng-template>
